export const checkDocAccess = (docRecord) => {
  console.log("docRecord", docRecord)
  if (!docRecord) return false;

  const docNumber = docRecord.sno || 1;

  if (docNumber <= 2) {
    return true;
  }
  if (Number(docRecord.type) === 2) {
    return true;
  }

  return false;
};
